import React from 'react'
import { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { LinkedDateCalendar } from '../js/LinkedCalendar.jsx';
import chrono from 'chrono-node';
/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = 767;
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 gsap.registerPlugin(Flip, ScrollTrigger, Draggable, InertiaPlugin);

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});



/*
 * Globals
 ***************************/
  /* Window */
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    var windowScrollHeight = document.querySelector('body').scrollHeight;
    const windowResizeActions = [];
  /* Breakpoints */
    var isMobile = ( windowWidth <= mobileBreakpoint );
  /* Navigation */
    var isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  console.log(keycode);
  if (keycode == '13' && $(event.target).is('button')) return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header').length ) {
    $('.site-header').each(function(){
      const nav = this;
      
      const bookingContainer = $('.site-booking');
      const bookingContainerInner = $('.site-booking-inner');
      const bookingDismiss = $('.site-booking-form__dismiss');
      const bookingToggle = $('.site-booking-form__toggle');
      let bookingOpen = false;

      const auxContainer = $(this).find('.site-header__nav-aux');
      let auxOpen = false;
      let auxCanAnimate = true;

      const menuToggle = $(this).find('.site-header__nav-menu__toggle');
      const menuDismiss = $(this).find('.site-header__nav-menu__dismiss');
      const menu = $(this).find('.site-header__nav-menu');
      const menuTL = gsap.timeline({
        paused: true,
        repeat: 0,
        onStart: function(){
          menu.css('visibility', 'visible');
          menu.css('pointer-events', 'auto');
        },
        onReverseComplete: function() {
          menu.css('visibility', 'hidden');
          menu.css('pointer-events', 'none');
        },
        onComplete: function() {
          menu.addClass('active');
          auxCanAnimate = true;
          document.querySelector('.site-header__nav-menu').focus();
        }
      });

      menu.css('visibility', 'hidden');

      menu.find('.menu > li').each(function() {
        gsap.set(this, {
          opacity: 0
        });

        menuTL.to(this, {
          opacity: 1,
          duration: 0.3
        }, '-=0.2');
      });

      const firstFocusableMenuElement = $(menu).find('.site-header__nav-menu__dismiss').get(0);
      const lastFocusableMenuElement = $(menu).find('input, button, a').eq($(menu).find('input, button, a').length - 1).get(0);
      const lastFocusableMobileMenuElement = $(menu).find('.menu a').eq( $(menu).find('.menu a').length - 1 ).get(0);



      if ( $('.site-header__nav-menu__socials').length ) {
        $('.site-header__nav-menu__socials li').each(function(){
          gsap.set(this, {
            opacity: 0
          });

          menuTL.to(this, {
            opacity: 1,
            duration: 0.3
          }, '-=0.26');
        });
      }

      const searchToggle = $(this).find('.site-header__nav-search__toggle');
      const searchDismiss = $(this).find('.site-header__nav-search__dismiss');
      const search = $(this).find('.site-header__nav-search');
      const searchTL = gsap.timeline({
        paused: true,
        repeat: 0,
        onStart: function(){
          search.css('visibility', 'visible');
          search.css('pointer-events', 'auto');
        },
        onReverseComplete: function() {
          search.css('visibility', 'hidden');
          search.css('pointer-events', 'none');
        },
        onComplete: function() {
          search.addClass('active');
          auxCanAnimate = true;
          $(search).find('input[type="search"]').get(0).focus();
        }
      });

      const firstFocusableSearchElement = $(search).find('.site-header__nav-search__dismiss').get(0);
      const lastFocusableSearchElement = $(search).find('input, button, a').eq($(search).find('input, button, a').length - 1).get(0);

      search.css('visibility', 'hidden');

      gsap.set(search.find('.search-form'), {
        opacity: 0
      });

      searchTL.to(search.find('.search-form'), {
        opacity: 1
      });

      if ( $('.site-header__nav-search__popular-container').length ) {
        gsap.set($('.site-header__nav-search__popular-container > h2'), {
          opacity: 0
        });

        searchTL.to($('.site-header__nav-search__popular-container > h2'), {
          opacity: 1
        }, '-=0.4');

        $('.site-header__nav-search__popular-item').each(function(){
          gsap.set(this, {
            opacity: 0
          });

          searchTL.to(this, {
            opacity: 1,
          }, '-=0.4');
        });
      }
      
      gsap.set(bookingContainerInner, {
        x: '100%'
      });
      
      const closeBooking = (callback) => {
        if ( auxCanAnimate ) {
          auxCanAnimate = false;
          bookingOpen = false;
          $('body').removeClass('no-scroll');
          const closeTL = gsap.timeline({
            repeat: false,
            onComplete: function() {
              bookingContainer.css({
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
              auxCanAnimate = true;
              callback();
            }
          })
          
          closeTL.to(bookingContainerInner, {
            x: '100%',
            duration: 0.8,
            ease: 'power3.inOut',
          });
          
          closeTL.to(bookingContainer, {
            backgroundColor: 'rgba(0,0,0,0)',
            duration: 0.8,
            ease: 'power3.inOut',
          }, '<');
          
          closeTL.play();
        }
      };
      
      const openBooking = (callback) => {
        if ( auxCanAnimate ) {
          auxCanAnimate = false;
          bookingOpen = true;
          bookingContainer.css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });
          $('body').addClass('no-scroll');
          const openTL = gsap.timeline({
            repeat: false,
            onComplete: function() {
              auxCanAnimate = true;
              callback();
            }
          })
          
          openTL.to(bookingContainerInner, {
            x: 0,
            duration: 0.8,
            ease: 'power3.inOut',
          });
          
          openTL.to(bookingContainer, {
            backgroundColor: 'rgba(0,0,0,0.5)',
            duration: 0.8,
            ease: 'power3.inOut',
          }, '<');
          
          openTL.play();
        }
      };
      
      $('.site-booking-form__toggle').on('click', function(){
        openBooking(function(){
          bookingDismiss.focus();
        });
      });
      
      $(bookingDismiss).on('click', function(){
        closeBooking(function(){
          bookingToggle.focus();
        });
      });
      
      $(bookingContainer).on('click', function(e){
        if ( e.target !== bookingContainerInner.get(0) && !bookingContainerInner.get(0).contains( e.target ) ) {
          bookingDismiss.click();
        }
      });
      
      const firstFocusableBookingElement = $(bookingContainer).find('input, button, a').get(0);
      const lastFocusableBookingElement = $(bookingContainer).find('input, button, a').eq($(bookingContainer).find('input, button, a').length - 1).get(0);
      
      $(bookingContainer).on('keydown', function(e){
        if ( e.key == 'Escape' ) {
          bookingDismiss.click();
        } if(e.target == firstFocusableBookingElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableBookingElement.focus();
        } else if(e.target == lastFocusableBookingElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableBookingElement.focus();
        }
      });
      

      auxContainer.css('visibility', 'hidden');

      const closeAux = (callback) => {
        if ( auxCanAnimate ) {
          auxCanAnimate = false;
          $(nav).removeClass('auxopen');
          $('body').removeClass('no-scroll');
          auxOpen = false;

          gsap.to(auxContainer, {
            x: '+=100%',
            duration: 0.8,
            ease: 'power3.inOut',
            onComplete: () => {
              auxContainer.css('visibility', 'hidden');
              auxCanAnimate = true;
              callback();
            }
          });
        }
      };

      const openAux = (callback) => {
        if ( auxCanAnimate ) {
          auxCanAnimate = false;
          auxContainer.css('visibility', 'visible');
          $(nav).addClass('auxopen');
          $('body').addClass('no-scroll');
          auxOpen = true;
          gsap.to(auxContainer, {
            x: '-=100%',
            duration: 0.8,
            ease: 'power3.inOut',
            onComplete: () => {
              auxCanAnimate = true;
              callback();
            }
          });
        }
      };

      $(menuDismiss).on('click', function(){
        if ( auxCanAnimate && auxOpen ) {
          closeAux(() => {
            $(menu).removeClass('active');
            $(menu).css('visibility', 'hidden');
            menu.css('pointer-events', 'none');
            $(menuToggle).focus();
            $(menuToggle).removeClass('active');
          });
        }
      }).on('keypress', handleKeypressADA);

      $(menu).on('keydown', function(e){
        if ( e.key == 'Escape' ) {
          menuDismiss.click();
        } if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          if ( isMobile ) {
            lastFocusableMobileMenuElement.focus();
          } else {
            lastFocusableMenuElement.focus();
          }
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        } else if ( isMobile && e.target == lastFocusableMobileMenuElement && e.key == 'Tab' && !e.shiftKey  ) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      });

      $(menuToggle).on('click', function(){
        if ( auxCanAnimate ) {
          if ( auxOpen ) {
            if ( $(menu).hasClass('active') ) { // this is open, close menu
              menuToggle.removeClass('active');
              closeAux(() => {
                $(menu).removeClass('active');
                menu.css('visibility', 'hidden');
                menu.css('pointer-events', 'none');
              });
            } else { // search is open, swap
              searchTL.eventCallback('onReverseComplete', () => {
                search.removeClass('active');
                search.css('visibility', 'hidden');
                search.css('pointer-events', 'none');
                menuToggle.addClass('active');
                menuTL.play(0);
                searchTL.pause();
                searchTL.reversed(false);
                searchTL.eventCallback('onReverseComplete', ()=>{
                  search.removeClass('active');
                  search.css('visibility', 'hidden');
                  search.css('pointer-events', 'none');
                });
              });
              auxCanAnimate = false;
              searchTL.reverse(0);
              searchToggle.removeClass('active');
            }
          } else { // nothing is open, open menu
            menuTL.seek(menuTL.duration());
            menu.css('visibility', 'visible');
            menu.css('pointer-events', 'auto');
            menuToggle.addClass('active');
            openAux(() => {
              $(menu).addClass('active');
              document.querySelector('.site-header__nav-menu').focus();
            });
          }
        }
      }).on('keypress', handleKeypressADA);

      $(searchDismiss).on('click', function(){
        if ( auxCanAnimate && auxOpen ) {
          closeAux(() => {
            $(search).removeClass('active');
            $(search).css('visibility', 'hidden');
            $(search).css('pointer-events', 'none');
            $(searchToggle).focus();
            $(searchToggle).removeClass('active');
          });
        }
      }).on('keypress', handleKeypressADA);

      $(search).on('keydown', function(e){
        if ( e.key == 'Escape' ) {
          searchDismiss.click();
        } else if(e.target == firstFocusableSearchElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableSearchElement.focus();
        } else if(e.target == lastFocusableSearchElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableSearchElement.focus();
        }
      });

      $(searchToggle).on('click', function(){
        if ( auxCanAnimate ) {
          if ( auxOpen ) {
            if ( $(search).hasClass('active') ) { // this is open, close menu
              searchToggle.removeClass('active');
              closeAux(() => {
                $(search).removeClass('active');
                search.css('visibility', 'hidden');
                search.css('pointer-events', 'none');
              });
            } else { // menu is open, swap
              menuTL.eventCallback('onReverseComplete', () => {
                menu.removeClass('active');
                menu.css('visibility', 'hidden');
                menu.css('pointer-events', 'none');
                searchToggle.addClass('active');
                searchTL.play(0);
                menuTL.pause();
                menuTL.reversed(false);
                menuTL.eventCallback('onReverseComplete', ()=>{
                  menu.removeClass('active');
                  menu.css('visibility', 'hidden');
                  menu.css('pointer-events', 'none');
                });
              });
              auxCanAnimate = false;
              menuTL.reverse(0);
              menuToggle.removeClass('active');
            }
          } else { // nothing is open, open menu
            searchTL.seek(searchTL.duration());
            search.css('visibility', 'visible');
            search.css('pointer-events', 'auto');
            searchToggle.addClass('active');
            openAux(() => {
              $(search).addClass('active');
              $(search).find('input[type="search"]').focus();
            });
          }
        }
      }).on('keypress', handleKeypressADA);

      $(menu).find('.menu-item-has-children > a').each(function(index){
        const thisRef = $(this);
        const submenu = $(this).parent().find('.sub-menu');
        const submenuItems = $(submenu).find('li');
        const id = $(this).parent().attr('id');
        submenu.attr('id', id + '-submenu');
        
        this.setAttribute('aria-controls', id + '-submenu');
        this.setAttribute('aria-expanded', 'false');
        this.setAttribute('role', 'button');

        const resizeFunc = () => {
          if ( $(window).width() < parseInt(breakpoints.tablet_min) ) {
            if ( $(thisRef).hasClass('active') ) {
              gsap.set(submenuItems, {
                opacity: 1
              });

              gsap.set(submenu, {
                height: 'auto'
              });
            } else {
              gsap.set(submenuItems, {
                opacity: 1
              });

              gsap.set(submenu, {
                height: 0
              });
            }


          } else {
            if ( $(thisRef).hasClass('active') ) {
              gsap.set(submenuItems, {
                opacity: 1
              });

              gsap.set(submenu, {
                height: 'auto'
              });
            } else {
              gsap.set(submenuItems, {
                opacity: 0
              });

              gsap.set(submenu, {
                height: 'auto'
              });
            }
          }
        };

        resizeFunc();

        $(window).on('resize', function() {
          resizeFunc();
        });

        $(this).on('click', function(e){
          e.preventDefault();
          let submenuTL;

          if ( !isMobile ) {
            submenuTL = gsap.timeline({
              paused: true,
              repeat: 0,
            });

            $(submenuItems).each(function(){
              submenuTL.to(this, {
                opacity: $(thisRef).hasClass('active') ? 0 : 1,
                duration: 0.3
              }, '-=0.2');
            });
          } else {
            submenuTL = gsap.timeline({
              paused: true,
              repeat: 0,
            });

            submenuTL.to(submenu, {
              height: $(thisRef).hasClass('active') ? 0 : 'auto'
            });
          }

          if ( $(this).hasClass('active') ) {
            $(this).attr('aria-expanded', 'false');
            $(this).toggleClass('active');
            submenuTL.eventCallback('onComplete', function(){
              submenu.css('visibility', 'hidden');
              submenu.css('pointer-events', 'none');
            });
            submenuTL.play();
          } else if ( $(menu).find('.menu-item-has-children > a.active').length ) {
            $(this).attr('aria-expanded', 'true');
            const activesubmenu = $(menu).find('.menu-item-has-children > a.active').parent().find('.sub-menu');
            const activesubmenuItems = $(activesubmenu).find('li');
            const activesubmenuTL = gsap.timeline({
              paused: true,
              repeat: 0,
              onComplete: function() {
                activesubmenu.css('visibility', 'hidden');
                activesubmenu.css('pointer-events', 'none');
                submenu.css('visibility', 'visible');
                submenu.css('pointer-events', 'auto');
                submenuTL.play();
              }
            });

            if ( !isMobile ) {
              $(activesubmenuItems).each(function(){
                activesubmenuTL.to(this, {
                  opacity: 0,
                  duration: 0.3
                }, '-=0.2');
              });
            } else {
              activesubmenuTL.to(activesubmenu, {
                height: 0,
              });
            }



            $(menu).find('.menu-item-has-children > a.active').removeClass('active');
            $(this).toggleClass('active');
            activesubmenuTL.play();
          } else {
            $(this).attr('aria-expanded', 'true');
            $(this).toggleClass('active');
            submenu.css('visibility', 'visible');
            submenu.css('pointer-events', 'auto');
            submenuTL.play();
          }
        }).on('keypress', handleKeypressADA);
      });
      
    });
  }
  
  // dropdowns
  if ( $('.cmykpress-dropdown').length ) {

    $('.cmykpress-dropdown').each(function(){
      const container = this;
      const trigger = this.querySelector('.cmykpress-dropdown__toggle');
      const inner = this.querySelector('.cmykpress-dropdown__inner');
      const selectedText = trigger.querySelector('span');
      const optionsList = this.querySelector('.cmykpress-dropdown__dropdown');  
      const options = this.querySelectorAll('.cmykpress-dropdown__dropdown li');
      const hiddenField = this.querySelector('.cmykpress-dropdown__hidden-input');
      const labelEx = options;

      let isExpanded = false;

      $(optionsList).css({
        width: 'auto'
      });

      console.log(  Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px' );
      
      $(inner).css({
        'width': Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px'
      });
      
      $(optionsList).css({
        width: '100%'
      });

      /**
        Event handlers
      */
      const handleTriggerKeypresses = function (e) {
        switch(e.key) {
          case 'ArrowUp':
            e.preventDefault();
            
            if(isExpanded) {
              highlightPreviousOption();
            } else {
              expandOptions();
            }
            
            break;
            
          case 'ArrowDown':
            e.preventDefault();
            
            if(isExpanded) {
              var highlightedOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
              
              if(highlightedOption !== null && highlightedOption !== undefined) {
                highlightNextOption();
              } else {
                highlightFirstOption();
              }
            } else {
              expandOptions();
            }
            
            break;
          case 'Home':
            if(isExpanded) {
              highlightFirstOption();
            }
            
            break;
            
          case 'End':
            if(isExpanded) {
              highlightLastOption();
            }
            
            break;
            
          case 'Tab':
            collapseOptions();
            break;
            
          case 'Escape':
            if(isExpanded) {
              e.preventDefault();
              collapseOptions();
              if ( e.target.closest('[aria-modal="true"]') !== null ) {
                e.stopPropagation();
              }
            }
            
            break;
            
          case 'Enter':
            e.preventDefault();
            
            if(isExpanded) {
              var highlightedOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
              
              if(highlightedOption !== null && highlightedOption !== undefined) {
                selectOption(highlightedOption);
              }
              
              collapseOptions();
              if ( e.target.closest('[aria-modal="true"]') !== null ) {
                e.stopPropagation();
              }
            } else {
              expandOptions();
            }
            
            break;
        }
      }

      const handleBodyClick = function (e) {
        if(!container.contains(e.target) && isExpanded) {
          collapseOptions();
        }
      }

      const handleTriggerClick = function () {
        if(isExpanded) {
          collapseOptions();
          trigger.focus();
        } else {
          expandOptions();
        }
      }


      /**
        Show/hide option list
      */
      const collapseOptions = function () {
        trigger.setAttribute('aria-expanded', false);
        optionsList.classList.remove('is-visible');
        isExpanded = false;
      }

      const expandOptions = function () {
        trigger.setAttribute('aria-expanded', true);
        optionsList.classList.add('is-visible');
        isExpanded = true;
      }


      /**
        Option selection
      */
      const highlightFirstOption = function () {
        var firstOption = options[0];
        highlightOption(firstOption);
      }

      const highlightLastOption = function () {
        var lastOption = options[options.length-1];
        highlightOption(lastOption);
      }

      const highlightNextOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== null && currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            highlightOption(nextOption);
          }
        }
      }

      const highlightPreviousOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== null && currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex - 1 >= 0) {
            var previousOption = options[currentOptionIndex - 1];
            highlightOption(previousOption);
          }
        }
      }

      const highlightOption = function (option) {
        removeHighlight();
        option.setAttribute('aria-selected', true);
        trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
        selectedText.innerHTML = option.innerHTML;
        
        // Scroll item into view
      }

      const selectOption = function (option) {
        // Update the hidden field
        hiddenField.value = $(option).data('value');
        $(hiddenField).trigger('change');
      }

      const removeHighlight = function () {  
        options.forEach(function(option) {
          option.removeAttribute('aria-selected');
        });
      }

      // Handle keyboard and mouse interactions on the trigger bar
      // remove if this is link dropdown
      const isLinkDropdown = [...options].some(option => option.querySelector('a') !== null);
      trigger.addEventListener('click', handleTriggerClick);
      if(!isLinkDropdown) {
        trigger.addEventListener('keydown', handleTriggerKeypresses);

        // Select options when they are clicked
        options.forEach(function(option) {
          option.addEventListener('click', function(e) {
            removeHighlight();
            highlightOption(e.target);
            selectOption(e.target);
            collapseOptions();
            trigger.focus();
          });
        });
      }
      
      
      
      // Collapse the dropdown when the user clicks off
      document.addEventListener('click', handleBodyClick);
    });
  }

  if ( $('.site-booking-form__num-spinner').length ) {
    $('.site-booking-form__num-spinner').each(function(){
      const input = $(this).find('input[type="number"]');
      const minusBtn = $(this).find('.site-booking-form__num-spinner-btn.decrease');
      const plusBtn = $(this).find('.site-booking-form__num-spinner-btn.increase');

      minusBtn.on('click', function(){
        let currentVal = parseInt(input.val());
        if ( currentVal > parseInt(input.attr('min')) ) {
          input.val(currentVal - 1);
          input.trigger('change');
          plusBtn.attr('disabled', false);
          if ( input.val() == input.attr('min') ) {
            minusBtn.attr('disabled', true);
          }
        }
      });

      plusBtn.on('click', function(){
        let currentVal = parseInt(input.val());
        if ( input.get(0).hasAttribute('max') && currentVal < parseInt(input.attr('max')) ) {
          input.val(currentVal + 1);
          input.trigger('change');
          minusBtn.attr('disabled', false);
          if ( input.val() == input.attr('max') ) {
            plusBtn.attr('disabled', true);
          }
        }
      });
    });
  }
  
  if ( $('.site-booking-form__form').length ) {
    $('.site-booking-form__form').each(function(){
      const siteBookingForm = this;
      const calendarContainer = siteBookingForm.querySelector('.site-booking-form__calendar');
      const root = createRoot( calendarContainer );
      const namespace = $(this).closest('.site-booking-form').attr('id');
      const roomsInput = $(this).find('input[name="rooms"]');
      
      const startDateInput = siteBookingForm.querySelector('.site-booking-form__start-date');
      const endDateInput = siteBookingForm.querySelector('.site-booking-form__end-date');
      const dateRangeInput = siteBookingForm.querySelector('.site-booking-form__daterange-input');

      const codeTypeInput = $(this).find('input[name="code-type"]');
      const codeTypeRow = $(this).find('.site-booking-form__form-row.code-type');
      const codeRows = $(this).find('.site-booking-form__form-row.code');
      const codeClearBtn = $(this).find('.site-booking-form__form-row-code-clear-btn');

      codeTypeInput.on('change', function(){
        $(codeRows).hide();
        
        if ( $(this).val() == '' ) {
          codeTypeRow.show();
        } else {
          codeRows.filter('.' + $(this).val() ).show().find('input[type="text"]').first().focus();
        }
      });

      codeClearBtn.on('click', function(){
        $(this).closest('.site-booking-form__form-row').find('input[type="text"]').val('');
        codeTypeInput.val('');
        codeTypeInput.trigger('change');
      });
      
      const onChange = (startDate, endDate) => {
        console.log(startDate, endDate );
        let dateStr = '';
        if ( startDate ) {
          $(startDateInput).val( ('0' + (startDate.getMonth()+1)).slice(-2) + '/'
             + ('0' + startDate.getDate()).slice(-2) + '/'
             + ( '' + startDate.getFullYear())  );
           $(startDateInput).trigger('change');
           
           dateStr += ('0' + (startDate.getMonth()+1)).slice(-2) + '/'
             + ('0' + startDate.getDate()).slice(-2) + '/'
             + ( '' + startDate.getFullYear()).slice(-2);
        }
        
        
        if ( endDate ) {
          $(endDateInput).val( ('0' + (endDate.getMonth()+1)).slice(-2) + '/'
             + ('0' + endDate.getDate()).slice(-2) + '/'
             + ( '' + endDate.getFullYear())  );
           $(endDateInput).trigger('change');
           
           if ( dateStr !== '' ) {
             dateStr += ' - ' + ('0' + (endDate.getMonth()+1)).slice(-2) + '/'
             + ('0' + endDate.getDate()).slice(-2) + '/'
             + ( '' + endDate.getFullYear()).slice(-2);
           } else {
             dateStr += ('0' + (endDate.getMonth()+1)).slice(-2) + '/'
             + ('0' + endDate.getDate()).slice(-2) + '/'
             + ( '' + endDate.getFullYear()).slice(-2);
           }
           
        }
        
        $(dateRangeInput).val( dateStr );
      };
      
      const monthsShown = $(this).hasClass('static') ? 2 : 1;
      
      const promoCodeInput = $(this).find('input[name="promo"]');
      const groupCodeInput = $(this).find('input[name="group"]');
      
      $(dateRangeInput).on('change', function(){
        let rawVal = this.value;
        const parsed = chrono.parse( rawVal );
        console.log(parsed);
      });
      
      const minDateExceptions = [
        {
          input: $(this).find('input[name="hotel"]').get(0),
          value: 45899,
          minDate: new Date('November 18, 2024 00:00:00')
        }
      ];
      
      let initialMinDate = false;
      for ( let i = 0; i < minDateExceptions.length; i++ ) {
        if ( typeof minDateExceptions[i].input !== 'undefined' && minDateExceptions[i].input.value == minDateExceptions[i].value && minDateExceptions[i].minDate > new Date() ) {
          initialMinDate = minDateExceptions[i].minDate;
        }
      }
      
      const windowObj = $(window);
      
      root.render((
        <LinkedDateCalendar
        onChangeCallback={ onChange }
        monthsShown={ monthsShown }
        initialMinDate={ initialMinDate }
        exceptions={ minDateExceptions }
        hotelInputSet={ $(this).find('input[name="hotel"]') }
        windowObj={ windowObj }
         />
      ));
      
      if ( $(this).hasClass('static') ) {
        let calendarIsOpen = false;
        
        $(calendarContainer).css({
          'pointer-events': 'none',
          'visibility': 'hidden'
        });
        
        gsap.set(calendarContainer, {
          opacity: 0
        });
        
        const openCalendar = () => {
          calendarIsOpen = true;
          $(calendarContainer).css({
            'pointer-events': 'auto',
            'visibility': 'visible'
          });
          
          gsap.to(calendarContainer, {
            opacity: 1,
            duration: 0.4
          })
        };
        
        const closeCalendar = () => {
          calendarIsOpen = false;
          gsap.to(calendarContainer, {
            opacity: 0,
            duration: 0.4,
            onComplete: function() {
              $(calendarContainer).css({
                'pointer-events': 'none',
                'visibility': 'hidden'
              });
            }
          });
        };
        
        $(dateRangeInput).on('click', function() {
          openCalendar();
        });
        
        $(document).on('click', function(e){
          if ( calendarIsOpen ) {
            if ( e.target !== calendarContainer && !calendarContainer.contains(e.target) && e.target !== dateRangeInput && !e.target.classList.contains('react-datepicker__day') && !e.target.classList.contains('react-datepicker__navigation') ) {
              closeCalendar();
            }
          }
        });
      }

      let automaticBookingCode = false;
      const currentSite = Object.values(siteInformation).find( site => site.hasOwnProperty('synxis_hotel_id') && site.synxis_hotel_id == $(this).find('input[name="hotel"]').val() );
      if ( typeof currentSite !== 'undefined' && currentSite.hasOwnProperty('auto_promo_code') && currentSite.auto_promo_code !== false ) {
        automaticBookingCode = currentSite.auto_promo_code;
      } else if ( siteInformation[1].hasOwnProperty('auto_promo_code') && siteInformation[1].auto_promo_code !== false ) {
        automaticBookingCode = siteInformation[1].auto_promo_code;
      }

      const originalAction = $(this).attr('action');
      const hotelInput = $(this).find('input[name="hotel"]');
      const formEl = this;
      $(roomsInput).on('change', function(){
        if ( parseInt($(this).val()) > 9 ) {
          const site = Object.values(siteInformation).find( site => site.hasOwnProperty('synxis_hotel_id') && site.synxis_hotel_id == hotelInput.val() );
          if ( typeof site !== 'undefined' && site.hasOwnProperty('group_booking') && site.group_booking !== false ) {
            formEl.setAttribute('action', site.group_booking );
          } else if ( siteInformation[1].hasOwnProperty('group_booking') && siteInformation[1].group_booking !== false ) {
            formEl.setAttribute('action', siteInformation[1].group_booking);
          }
        } else {
          formEl.setAttribute('action', originalAction);
        }
      });

      $(hotelInput).on('change', function() {
        const site = Object.values(siteInformation).find( site => site.hasOwnProperty('synxis_hotel_id') && site.synxis_hotel_id == hotelInput.val() );
        if ( parseInt($(roomsInput).val()) > 9 ) {
          if ( typeof site !== 'undefined' && site.hasOwnProperty('group_booking') && site.group_booking !== false ) {
            formEl.setAttribute('action', site.group_booking );
          } else if ( siteInformation[1].hasOwnProperty('group_booking') && siteInformation[1].group_booking !== false ) {
            formEl.setAttribute('action', siteInformation[1].group_booking);
          }
        } else {
          formEl.setAttribute('action', originalAction);
        }

        if ( site !== 'undefined' && site.hasOwnProperty('auto_promo_code') && site.auto_promo_code !== false ) {
          automaticBookingCode = site.auto_promo_code;
        } else if ( siteInformation[1].hasOwnProperty('auto_promo_code') && siteInformation[1].auto_promo_code !== false ) {
          automaticBookingCode = siteInformation[1].auto_promo_code;
        }
      });

      $(this).on('submit', function(e){
        // if there is more than one room, we need to break the guests parameter into rooms
        const rooms = parseInt(roomsInput.val());
        if ( rooms > 1 && rooms <= 9 ) {
          // dont do this for group booking redirects
          const guestsInput = $(siteBookingForm).find('input[name="adult"]');
          const guests = parseInt(guestsInput.val());
          console.log(guests);
          const guestsStr = [];
          for ( let i = 0; i < rooms; i++ ) {
            guestsStr.push(guests);
          }

          // guestsInput.attr('type', 'text');
          guestsInput.val( guestsStr.join(',') );

          setTimeout(function(){
            guestsInput.val( guests );
            // guestsInput.attr('type', 'number');
          }, 100);
        }


        // if there is an automatic code for this hotel and no code has been entered, set the code field to the automatic code so it gets sent with the form, then clear it immediately after so the user doesn't see it populated if they return to the form
        if ( automaticBookingCode !== false && $(promoCodeInput).val() == '' && $(groupCodeInput).val() == '' ) {
          console.log('setting automatic code: ' + automaticBookingCode );
          promoCodeInput.val( automaticBookingCode );
        }

        setTimeout(function(){
          promoCodeInput.val( '' );
        }, 100);
        return true;
      })
    });
  }
  
  if ( $('.site-header__nav-search-inner').length ) {
    $('.site-header__nav-search-inner').each(function() {
      const input = $(this).find('input[type="search"]');
      const label = $(this).find('.search-form__label');
      
      input.on('change', function() {
        console.log(this.value);
        if ( this.value == '' ) {
          label.addClass('no-input');
        } else {
          label.removeClass('no-input');
        }
      });
    });
  }

  if ( $('.site-header__nav-hotels__container').length ) {
    $('.site-header__nav-hotels__container').each(function(){
      const thisRef = this;
      const hotelToggle = $(this).find('.site-header__nav-hotels__trigger');
      const hotelList = $(this).find('.site-header__nav-hotels');
      const hotelListItems = $(this).find('.site-header__nav-hotels-item');
      const hotelTL = gsap.timeline({
        paused: true,
        repeat: 0,
        onStart: function() {
          $(hotelList).css('visibility', 'visible');
          $(hotelList).css('pointer-events', 'auto');
        },
        onComplete: function(){
          $(hotelList).css('visibility', 'visible');
          $(hotelList).css('pointer-events', 'auto');
        },
        onReverseComplete: function(){
          $(hotelList).css('visibility', 'hidden');
          $(hotelList).css('pointer-events', 'none');
        }
      });

      $(hotelListItems).each(function(){
        const thisRef = this;
        hotelTL.to(this, {
          opacity: 1,
          duration: 0.3,
        }, '-=0.2')
      });

      const dur = hotelTL.duration();
      hotelTL.to(hotelList, {
        height: 'auto',
        duration: dur
      }, '-=' + dur);

      gsap.set(hotelList, {
        height: 0
      });

      hotelToggle.on('click', function(){
        $(hotelToggle).toggleClass('active');
        $(hotelToggle).attr('aria-expanded', $(hotelToggle).hasClass('active') ? 'true' : 'false');
        $(hotelToggle).hasClass('active') ? hotelTL.restart() : hotelTL.reverse();
      }).on('keypress', handleKeypressADA);

      $(window).on('click', function(e){
        if ( $(hotelToggle).hasClass('active') ) {
          if ( e.target !== $(hotelToggle).get(0) && !$(hotelToggle).get(0).contains(e.target) && e.target !== $(hotelList) && !$(hotelList).get(0).contains(e.target) ) {
            $(hotelToggle).trigger('click');
          }
        }
      });
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* PARALLAX BACKGROUNDS */
  if ( $('.gif-pauser').length ) {
    $('.gif-pauser').each(function(){
      const thisRef = this;
      const gif = $(this).parent().prev('img').get(0);
      const playpause = this;
      const playpausetext = $(playpause).find('.gif-pauser__controls-playpause-text');
      if ( $(this).closest('a').length ) {
        const containerLink = $(this).closest('a').get(0);
        containerLink.after(thisRef);
      }
    });

    $(document).on('click', '.gif-pauser', function(){
      let gifstate = $(this).hasClass('playing') ? 'playing' : 'paused';
      let playpause = this;
      const gif = $(this).closest('.parallax-block__controls').length ? $(this).closest('.parallax-block').find('.parallax-block__background img').get(0) : $(this).parent().prev('img').get(0);

      if ( gifstate == 'playing' ) {
        gifstate = 'paused';
        console.log('hello????');
        freeze_gif( gif );
        
        $(playpause).removeClass('playing');
        $(playpause).addClass('paused');
      } else {
        gifstate = 'playing';
        gif.src = $(this).data('live');
        $(playpause).removeClass('paused');
        $(playpause).addClass('playing');
      }
    });
  }
  
  if ( $('.parallax-container').length ) {
    $('.parallax-container').each(function(){
      const container = this;
      const item = this.querySelector('.parallax-item');
      const startsTop = $(this).hasClass('starts-top');

      let navHeight = 74;
      navHeight = parseInt($('.site-header').outerHeight());
      windowResizeActions.push(function(updated){
        if ( updated ) {
          navHeight = parseInt($('.site-header').outerHeight());
        }
      });
      
      const scrollTrigger = ScrollTrigger.create({
        trigger: container,
        start: 'top bottom',
        end: 'bottom top',
      });


      if ( $(item).find('iframe').length ) {
        const iframe = $(item).find('iframe').get(0);
        if ( !iframe.src.includes('vimeo') ) return;

        const initializePlayer = () => {
          const player = new Vimeo.Player(iframe);

          let videostate = 'playing';
          const playpause = $(this).find('.parallax-block__controls-playpause');
          const playpausetext = $(playpause).find('.parallax-block__controls-playpause-text');
          playpause.on('click', function(){
            if ( videostate == 'playing' ) {
              videostate = 'paused';
              player.pause();
              $(this).removeClass('playing');
              $(this).addClass('paused');
              $(playpausetext).text( $(this).data('playtext') );
            } else {
              videostate = 'playing';
              player.play();
              $(this).removeClass('paused');
              $(this).addClass('playing');
              $(playpausetext).text( $(this).data('pausetext') );
            }
          }).on('keypress', handleKeypressADA);
          
          $(playpause).addClass('hidden');
          
          ScrollTrigger.create({
            trigger: container,
            start: 'top bottom',
            end: 'bottom bottom',
            onEnter: function() {
              $(playpause).removeClass('hidden');
            },
            onLeave: function() {
              $(playpause).addClass('hidden');
            },
            onEnterBack: function() {
              $(playpause).removeClass('hidden');
            },
            onLeaveBack: function() {
              $(playpause).addClass('hidden');
            }
          });
        }

        if ( arloHasConsent('functional') ) {
          initializePlayer();
        } else {
          document.addEventListener("cookieyes_consent_update", function (event) {
            if ( arloHasConsent('functional') ) {
              initializePlayer();
            }
          });
        }
        
      }
      
      if ( $(item).find('.gif-pauser').length ) {
        const playpause = $(this).find('.gif-pauser').get(0);
        const controls = document.createElement('div');
        controls.classList.add('parallax-block__controls');
        container.prepend(controls);
        controls.append(playpause);
        
        $(playpause).addClass('hidden');
        
        ScrollTrigger.create({
          trigger: container,
          start: 'top bottom',
          end: 'bottom bottom',
          onEnter: function() {
            $(playpause).removeClass('hidden');
          },
          onLeave: function() {
            $(playpause).addClass('hidden');
          },
          onEnterBack: function() {
            $(playpause).removeClass('hidden');
          },
          onLeaveBack: function() {
            $(playpause).addClass('hidden');
          }
        });
      }

      if ( $(this).find('.parallax-hero').length ) {
        $(this).find('.parallax-hero').each(function(){
          if ( $(this).find('.parallax-hero__inner').children('h1, h2, h3, h4, h5, h6, p, ul, ol').length === 0 ) return;

          ScrollTrigger.create({
            trigger: this,
            start: 'top bottom',
            end: function() {
              return 'bottom top+=' + navHeight;
            },
            toggleClass: {
              targets: item,
              className: 'has-overlay'
            }
          })
        });
      }
    });
  }
  
  if ( $('.arlo-coupon').length ) {
    $('.arlo-coupon').each(function(){
      const trigger = $(this).find('.arlo-coupon__trigger');
      const container = $(this).find('.arlo-coupon__container');
      // const targetEl = $(this).find('.arlo-coupon__container input').get(0);
      const alertEl = $(this).find('.arlo-coupon__container__copynotice').get(0);
      const targetEl = $(this).find('.arlo-coupon__container-copylink').get(0);
      const sharer = $(this).find('.arlo-coupon__container__share');
      console.log(targetEl);
      
      if ( navigator.share ) {
        $(container).addClass('can-share');
      }
      
      trigger.on('click', function(e){
        e.preventDefault();
        const thisRef = this;
        
        container.attr('aria-hidden', 'false');
        
        gsap.to(this, {
          x: '-100%',
          duration: 0.3,
          ease: 'power3.inOut',
          onComplete: function() {
            $(thisRef).css({
              'pointer-events': 'none',
              'visibility': 'hidden'
            });
          }
        });
        
        targetEl.select()
        targetEl.setSelectionRange(0, 9999999);
        document.execCommand("copy");
        $(alertEl).fadeIn();
        setTimeout(function(){
          $(alertEl).fadeOut();
        }, 6000);
      });
      
      sharer.on('click', function(e){
        if ( navigator.share ) {
          navigator.share({
            title: document.title,
            text: targetEl.value,
            url: targetEl.value,
          })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error));
        } else {
          alert('Something went wrong trying to share this page!');
        }
      });
      
    });
  }

  /* GUTENBERG BLOCK SCRIPTS */
  // gallery

  if ( $('.article-card.has-gallery').length ) {
    $('.article-card.has-gallery').each(function(){
      const slick = $(this).find('.article-card__gallery');
      const upper = $(this).find('.article-card__gallery-controls');

      slick.slick({
        arrows: true,
        dots: false,
        arrowsPlacement: 'beforeSlides',
        // dots: true,
        // appendDots: upper,
        cssEase: "cubic-bezier(0.4, 0.0, 0.2, 1)",
        instructionsText: 'This is a carousel with slides displaying different images of the hotel room. Use the arrows to navigate between slides.'
      });
    });
  }

  if ( $('.arlo-happenings.no-filters .arlo-happenings__feed').length ) {
    $('.arlo-happenings.no-filters .arlo-happenings__feed').each(function(){
      const thisRef = this;
      // console.log(this);
      const setup_feed_slick = () => {
        if ( !$(thisRef).hasClass('slick-initialized') ) {
          $(thisRef).slick({
            dots: true,
            arrows: false,
            adaptiveHeight: true,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: parseInt(breakpoints.mobile_max),
                settings: 'unslick'
              }
            ]
          });
        }


        console.log({
          dots: true,
          arrows: false,
          adaptiveHeight: true,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: parseInt(breakpoints.mobile_max),
              settings: 'unslick'
            }
          ]
        });
      };

      if ( $(window).width() < parseInt(breakpoints.mobile_max) ) {
        setup_feed_slick();
      }

      $(window).on('resize', function() {
        if ( $(window).width() < parseInt(breakpoints.mobile_max) ) {
          setup_feed_slick();
        }
      })
    });
  }

  if ( $('.mobile-slider').length ) {
    $('.mobile-slider').each(function(){
      const inner = $(this).find('.mobile-slider__inner-blocks');
      const navContainer = $(this).find('.global-offers-carousel__nav');
       const instructions = this.hasAttribute('data-instructions') ? this.getAttribute('data-instructions') : 'This is a carousel of various content. Use the dot navigation to move to a specific slide.';

      const setupSlick = () => {
        if ( !$(inner).hasClass('slick-initialized') ) {
          $(inner).slick({
            dots: true,
            appendDots: navContainer,
            arrows: false,
            adaptiveHeight: false,
            mobileFirst: true,
            infinite: true,
            centerMode: true,
            centerPadding: '4.4rem',
            slidesToShow: 1,
            slidesToScroll: 1,
            instructionsText: instructions,
            responsive: [
              {
                breakpoint: parseInt(breakpoints.mobile_max),
                settings: 'unslick'
              }
            ]
          });
        }
      }

      if ( isMobile ) {
        setupSlick();
      }

      windowResizeActions.push(function(updated){
        if ( updated ) {
          if ( isMobile ) {
            setupSlick();
          }
        }
      });
    });
  }

  if ( $('.global-offers-carousel').length ) {
    $('.global-offers-carousel').each(function(){
      const container = this;
      const slick = $(this).find('.global-offers-carousel__slick');
      const numSlides = slick.children().length;

      if ( numSlides > 1 ) {
        const navContainer = $(this).find('.global-offers-carousel__nav');

        const slickArgs = {
          arrows: false,
          swipe: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '4.4rem',
          dots: true,
          instructionsText: 'This is a carousel of various special offers at Arlo Hotels. Use the dot navigation to move to a specific slide.',
          mobileFirst: true,
          regionLabel: 'Special Offers Carousel',
          appendDots: navContainer,
          responsive: [

          ]
        };

        const responsivePoints = [
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: parseInt(breakpoints.mobile_max),
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: parseInt(breakpoints.tablet_max),
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: parseInt(breakpoints.desktop_max),
            settings: {
              slidesToShow: 5,
            }
          }
        ];

        let needsDestroyRebuild = false;

        for (let i = 0; i < responsivePoints.length; i++) {
          const toAdd = responsivePoints[i];
          if ( numSlides > toAdd.settings.slidesToShow ) {
            slickArgs.responsive.push(toAdd);
          } else {
            slickArgs.responsive.push({
              breakpoint: toAdd.breakpoint,
              settings: 'unslick'
            });
            needsDestroyRebuild = toAdd.breakpoint;
            break;
          }
        }

        slick.on('destroy', function(){
          container.removeAttribute('aria-label');
          container.removeAttribute('role');
          slick.get(0).removeAttribute('aria-label');
          slick.get(0).removeAttribute('role');
          
        });
        slick.on('init', function(){
          slick.get(0).removeAttribute('aria-label');
          slick.get(0).removeAttribute('role');
          container.setAttribute('aria-label', 'Special Offers Carousel');
          container.setAttribute('role', 'region');
        });

        slick.slick(slickArgs);

        if ( needsDestroyRebuild !== false ) {
          $(window).on('resize', function(){
            if ( !slick.hasClass('slick-initialized') ) {
              if ( $(window).width() < needsDestroyRebuild ) {
                slick.slick(slickArgs);
              }
            }
          });
        }
      }
    });
  }

  if ( $('.archive-filters').length ) {
    const archiveBlock = $(this).parent();

    const updateFilters = () => {
      const activeFilters = {};

      $('.archive-filter-select').each(function(){
        activeFilters[$(this).attr('name')] = [$(this).val()];
      });

      $('.archive-select__hidden-input').each(function(){
        const hidden = this;
        activeFilters[ $(hidden).attr('name') ] = [ $(hidden).val() ];
      });
      
      $('.archive-filter-checkbox').each(function(){
        const name = $(this).attr('name');
        if ( $(this).is(':checked') ) {
          activeFilters[ name ] = true;
        } else {
          if ( activeFilters.hasOwnProperty( name ) ) {
            delete activeFilters[name];
          }
        }
      });

      const state = Flip.getState('.archive-feed, .archive-feed__list-item');
      $('.article-card').parent().show();

      $('.article-card').each(function(){
        let meetsCriteria = true;
        console.log(activeFilters);
        for (const prop in activeFilters) {
          console.log(prop);
          let passesThisFilter = false;
          if ( typeof activeFilters[prop] === 'boolean' ) {
            const data = $(this).data(prop);
            if ( data === 1 ) {
              passesThisFilter = true;
            }
          } else if ( ! activeFilters[prop].includes('allvalues') ) {
            const data = $(this).data(prop);
            if ( typeof data === 'string' && activeFilters[prop] === data ) {
              passesThisFilter = true;
            } else if ( Array.isArray(data) ) {
              for (let i = 0; i < data.length; i++) {
                console.log(activeFilters[prop], data[i]);
                if ( activeFilters[prop].includes( '' + data[i] ) ) {
                  passesThisFilter = true;
                }
              }
            }
          } else {
            passesThisFilter = true;
          }

          meetsCriteria = meetsCriteria && passesThisFilter;
        }

        if ( !meetsCriteria ) {
          $(this).parent().hide();
        }
      });

      if ( $('.archive-feed .slick-initialized').length ) {
        $('.archive-feed .slick-initialized').each(function(){
          $(this).slick('setPosition');
        });
      }

      Flip.from(state, {
        absolute: false, // uses position: absolute during the flip to work around flexbox challenges
        duration: 1.6,
        stagger: 0.1,
        ease: "power3.inOut",
        onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
        onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
        // you can use any other tweening properties here too, like onComplete, onUpdate, delay, etc.
      });
    }

    updateFilters();

    $(this).find('.archive-filter-checkbox').on('change', function(){
      updateFilters();
    });

    $('.archive-filter-select').on('change', function(){
      updateFilters();

      if ( $(this).val() == 'allvalues' ) {
        if ( $(this).hasClass('properties') ) {
          $('.archive-filter-select.city option').attr('disabled', false);
        } else if ( $(this).hasClass('city') ) {
          $('.archive-filter-select.properties option').attr('disabled', false);
        }
      } else {
        if ( $(this).hasClass('properties') ) {
          $('.archive-filter-select.city option').attr('disabled', true);
          $('.archive-filter-select.city option[data-city="' + $(this).find('option:selected').data('city') +'"]').attr('disabled', false);
        } else if ( $(this).hasClass('city') ) {
          $('.archive-filter-select.properties option').attr('disabled', true);
          $('.archive-filter-select.properties option[data-city="' + $(this).val() +'"]').attr('disabled', false);
        }
      }

      $('.archive-filter-select option[value="allvalues"]').attr('disabled', false);
    });

    if ( $('.archive-select__hidden-input').length ) {
      $('.archive-select__hidden-input').on('change', function(){
        updateFilters();
      });
    }
  }

  if ( $('.arlo-gallery').length ) {
    $('.arlo-gallery').each(function(){
      const slick = $(this).find('.arlo-gallery__images');
      const captions = $(this).find('.arlo-gallery__captions');
      const nav = $(this).find('.arlo-gallery__controls');

      slick.slick({
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: nav,
        asNavFor: captions,
        instructionsText: 'This is a carousel of images followed by a secondary carousel of accompanying captions. Use the arrows to navigate between slides. As you navigate the slides in this carousel, the second caption carousel will update to the corresponding caption associated with the image.',
        cssEase: "cubic-bezier(0.4, 0.0, 0.2, 1)",
        speed: 900,
        adaptiveHeight: true
      });

      captions.slick({
        arrows: false,
        cssEase: "cubic-bezier(0.4, 0.0, 0.2, 1)",
        adaptiveHeight: true,
        speed: 900
      })
    });
  }
  
  if ( $('.arlo-preview-gallery').length ) {
    $('.arlo-preview-gallery').each(function(){
      const slick = $(this).find('.arlo-preview-gallery__images');
      const captions = $(this).find('.arlo-preview-gallery__captions');
      const nav = $(this).find('.arlo-preview-gallery__arrows');
      const curNum = $(this).find('.arlo-preview-gallery__controls__count--cur');
  
      slick.slick({
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: nav,
        asNavFor: captions,
        instructionsText: 'This is a carousel of images followed by a secondary carousel of accompanying captions. Use the arrows to navigate between slides. As you navigate the slides in this carousel, the second caption carousel will update to the corresponding caption associated with the image.',
        cssEase: "cubic-bezier(0.4, 0.0, 0.2, 1)",
        centerMode: true,
        centerPadding: '25vw',
        speed: 900,
        adaptiveHeight: true
      });
  
      captions.slick({
        arrows: false,
        cssEase: "cubic-bezier(0.4, 0.0, 0.2, 1)",
        adaptiveHeight: true,
        speed: 900,
        fade: true
      });
      
      slick.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        curNum.text(((nextSlide + 1) + '').padStart(2, '0'));
      });
      
      $(this).addClass('slicked');
    });
  }

  if ( $('#floorplan').length ) {
    const modalBg = $('.floorplan-modal');
    const modalInner = modalBg.find('.floorplan-modal__inner');

    $('.floorplan-trigger').on('click', function(e){
      e.preventDefault();

      modalBg.css('visibility', 'visible');
      modalBg.css('pointer-events', 'auto');
      const modalTL = gsap.timeline({
        repeat: false,
        paused: true
      });

      modalTL.to(modalBg, {
        background: 'rgba(0,0,0,0.36)',
        duration: 0.6
      });

      modalTL.to(modalInner, {
        opacity: 1,
        scale: 1,
        duration: 0.6,
      }, '-=0.3');

      modalTL.play();
    }).on('keypress', handleKeypressADA);

    $('.floorplan-modal__dismiss').on('click', function(){
      const modalTL = gsap.timeline({
        repeat: false,
        paused: true,
        onComplete: function(){
          modalBg.css('visibility', 'hidden');
          modalBg.css('pointer-events', 'none');
        }
      });

      modalTL.to(modalInner, {
        opacity: 0,
        scale: 0.9,
        duration: 0.6,
      });

      modalTL.to(modalBg, {
        background: 'rgba(0,0,0,0)',
        duration: 0.6
      }, '-=0.3');

      modalTL.play();

    }).on('keypress', handleKeypressADA);

    const element = $('.floorplan-modal__inner').get(0);

    $('.floorplan-modal').on('click', function(e){
      if (e.target !== element && !element.contains(e.target)) {
        $('.floorplan-modal__dismiss').trigger('click');
      }
    });
  }

  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(index){
      const modal = document.createElement('div');
      $(modal).css('visibility', 'hidden');
      $(modal).css('pointer-events', 'none');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.classList.add('wp-block-gallery__lightbox');
      $(modal).attr('id', 'wp-block-gallery__lightbox-' + index);
      $(modal).attr('aria-labelledby', 'wp-block-gallery__lightbox-title-' + index);

      const modalTitle = document.createElement('h2');
      modalTitle.classList.add('screen-reader-text');
      modalTitle.setAttribute('id', 'wp-block-gallery__lightbox-title-' + index);
      modalTitle.textContent = 'Gallery';

      const modalClose = document.createElement('button');
      modalClose.setAttribute('type', 'button');
      modalClose.classList.add('wp-block-gallery__lightbox-close');
      modalClose.innerHTML = '<span class="screen-reader-text">Close gallery</span>';
      modal.appendChild(modalClose);
      modal.appendChild(modalTitle);

      const modalInner = document.createElement('div');
      modalInner.classList.add('wp-block-gallery__lightbox-inner');
      modal.appendChild(modalInner);

      const images = $(this).find('figure');
      $(images).each(function(){
        const slide = document.createElement('div');
        slide.classList.add('wp-block-gallery__lightbox-inner-slide');
        const clone = this.cloneNode(true);
        slide.appendChild(clone);
        modalInner.appendChild(slide);
      });

      $(modalInner).slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        cssEase: "cubic-bezier(0.4, 0.0, 0.2, 1)",
        instructionsText: 'This is a carousel with slides displaying different images of the hotel. Use the arrows to navigate between different slides, or the escape key or dismiss button to return to the page.',
        speed: 1200
      });

      let closeModal = false;
      let triggerelt = false;

      const escapeFunction = (e) => {
        if (e.key === "Escape") { // escape key maps to keycode `27`
          closeModal();
        }
      }

      closeModal = () => {
        $(document).unbind("keyup", escapeFunction);

        const modalTL = gsap.timeline({
          repeat: false,
          paused: true,
          onComplete: function(){
            $(modal).css('visibility', 'hidden');
            $(modal).css('pointer-events', 'none');
            $(images).find('img').attr('aria-expanded', 'false');
            if ( triggerelt ) {
              $(triggerelt).focus();
            }
          }
        });

        modalTL.to(modalInner, {
          opacity: 0,
          duration: 0.6,
        });

        modalTL.to(modal, {
          background: 'rgba(0,0,0,0)',
          duration: 0.6
        }, '-=0.3');

        modalTL.play();
      };

      $(modalClose).on('click', function(){
        closeModal();
      }).on('keypress', handleKeypressADA);

      $(images).find('img').each(function(index){
        $(this).attr('tabindex', 0);
        $(this).attr('role', 'button');
        $(this).attr('alt', 'Click this image or press enter on your keyboard to open this gallery in a modal. This image shows: ' + $(this).attr('alt'));
        $(this).attr('aria-controls', 'wp-block-gallery__lightbox-' + index);
        $(this).attr('aria-expanded', 'false');
        $(this).on('click', function(){
          triggerelt = this;
          $(document).on("keyup", escapeFunction);

          $(modal).css('visibility', 'visible');
          $(modal).css('pointer-events', 'auto');
          $(images).find('img').attr('aria-expanded', 'true');

          $(modalInner).slick('slickGoTo', index);

          const modalTL = gsap.timeline({
            repeat: false,
            paused: true,
            onComplete: function() {
              $(modalClose).focus();
            }
          });

          modalTL.to(modal, {
            background: 'rgba(0,0,0,0.72)',
            duration: 0.6
          });

          modalTL.to(modalInner, {
            opacity: 1,
            duration: 0.6,
          }, '-=0.3');

          modalTL.play();
        }).on('keypress', handleKeypressADA);
      });

      $(modal).on('click', function(e){
        if (e.target !== modalInner && !modalInner.contains(e.target)) {
          closeModal();
        }
      });

      const firstFocusableModalElement = modalClose;
      const lastFocusableModalElement = modal.querySelector('.slick-big-arrow.slick-next.slick-arrow');

      $(modal).on('keydown', function(e){
        if(e.target == firstFocusableModalElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableModalElement.focus();
        } else if(e.target == lastFocusableModalElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableModalElement.focus();
        }
      });

      document.querySelector('body').appendChild(modal);
    });
  }

  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }

  if ( $('.schema-faq-section').length ) {
    $('.schema-faq-section').each(function(index){
      const toggle = document.createElement('button');
      let title = $(this).find('.schema-faq-question').get(0);
      $(toggle).attr('aria-expanded', index == 0 ? 'true' : 'false');
      toggle.html( $(title).html() );
      toggle.appendChild(srText);
      
      $(title).replaceWith($('<h2 class="schema-faq-question"></h2>'));
      title = $(this).find('.schema-faq-question').get(0);
      const content = $(this).find('.schema-faq-answer');

      title.appendChild(toggle);

      if ( index !== 0 ) {
        content.hide();
      } else {
        $(title).addClass('expanded');
      }

      $(toggle).on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        $(title).toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }

  if ( $('.banner-block').length ) {
    $('.banner-block').each(function(){
      const bannerblock = this;
      let direction = -1;
      $('.banner-block__banner').each(function(){
        $(this).find('.banner-block__banner-inner').each(function(){
          const innerbannerTL = gsap.timeline({
            repeat: -1
          });

          innerbannerTL.to(this, {
            x: (100 * direction) + '%',
            ease: 'none',
            duration: 12
          });
        });

        const outerbannerTL = gsap.to(this.querySelector('.banner-block__banner-velocitymaker'), {
          scrollTrigger: {
            trigger: bannerblock,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 3,
          },
          x: (10 * direction) + '%',
        });

        direction = direction * -1;
      });
    });
  }

  if ( $('.address-trigger').length ) {
    $('.address-trigger').on('click', function(){
      var address = $(this).data('addr');
      address = $('<div/>')
        .html(address)
        .text() // strip tags
        .replace(/\s\s+/g, " "); // remove spaces
      address = encodeURIComponent(address);
      if ((navigator.platform.indexOf('iPhone') != -1) || (navigator.platform.indexOf('iPad') != -1) || (navigator.platform.indexOf('iPod') != -1) || (navigator.platform.indexOf('Mac') != -1) ){/* if we're on iOS, open in Apple Maps */
          window.open('http://maps.apple.com/?q=' + address);
      } else { /* else use Google */
          window.open('https://maps.google.com/maps?q=' + address);
      }
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.newsletter-capture').length ) {
    $('.newsletter-capture form').on('submit', function(e){
      $('#input_optinCheckbox').closest('.gfield').removeClass('gfield_error').find('.gfield_validation_message').remove();
      if ( !$('#input_optinCheckbox').is(':checked') ) {
        e.preventDefault();
        $('#input_optinCheckbox').next().addClass('error');
        $('#input_optinCheckbox').attr('aria-invalid', 'true');
        const id = $('#input_optinCheckbox').attr('id');
        $('#input_optinCheckbox').closest('.gfield').addClass('gfield_error').append('<div id="validation_message_'+ id +'" class="gfield_description validation_message gfield_validation_message">This field is required.</div>');
        $('#input_optinCheckbox').attr('aria-describedby', 'validation_message_' + id);
      } else {
        $('#input_optinCheckbox').next().removeClass('error');
        $('#input_optinCheckbox').attr('aria-invalid', 'false');
        $('#input_optinCheckbox').attr('aria-describedby', '');
      }

      let preventSubmit = false;
      $(this).find('.newsletter-required').each(function(){
        $(this).closest('.gfield').removeClass('gfield_error').find('.gfield_validation_message').remove();
        if ( $(this).val() == '' ) {
          preventSubmit = true;
          $(this).addClass('error');
          $(this).attr('aria-invalid', 'true');
          const id = $(this).attr('id');
          $(this).closest('.gfield').addClass('gfield_error').append('<div id="validation_message_'+ id +'" class="gfield_description validation_message gfield_validation_message">This field is required.</div>');
          $(this).attr('aria-describedby', 'validation_message_' + id);
        } else {
          $(this).removeClass('error');
          $(this).attr('aria-invalid', 'false');
          $(this).attr('aria-describedby', '');
        }
      });

      if ( preventSubmit ) {
        if ( !$('.newsletter-capture .gform_validation_errors').length ) {
          $('<div class="gform_validation_errors" id="gform_2_validation_container"><h2 class="gform_submission_error hide_summary"><span class="gform-icon gform-icon--close"></span>There was a problem with your submission. Please review the fields below.</h2></div>').insertBefore($('.newsletter-capture .form-heading'));
        }
        e.preventDefault();
      }
    });
  }

  if ( $('#resy-api-key').length ) {
    const key = $('#resy-api-key').data('key');
    $('a').each(function(){
      if ( ($(this).attr('href') + '').search('resy.com') !== -1 && $(this).data('venueid') ) {
        resyWidget.addButton(this, {
          "venueId": $(this).data('venueid'),
          "apiKey":key,
          "replace":true
        });
      }
    });
  }

  if ( $('.static-map-container').length ) {
    $('.static-map-container').each(function(){
      const slides = $(this).find('.static-map-container__wrap');
      const indicator = $(this).find('.map-container__citynav-indicator');
      const navitems = $(this).find('.map-container__citynav-item');
      const buttons = navitems.find('.map-container__citynav-item__button');
      const mobileToggle = $(this).find('.map-container__citynav__mobiletoggle');
      const list = $(this).find('.map-container__citynav');
      slides.slick({
        fade: true,
        arrows: false
      });

      slides.get(0).removeAttribute('role');
      slides.get(0).removeAttribute('aria-label');

      slides.find('.slick-slide').each(function() {
        this.removeAttribute('role');
        this.removeAttribute('aria-label')
      });
      

      buttons.each(function(index) {
        $(this).on('click', function(){
          slides.slick('slickGoTo', index);
        }).on('keypress', handleKeypressADA);
      });

      slides.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        slides.find('.slick-slide').attr('aria-label', '')
        navitems.removeClass('active');
        buttons.attr('aria-current', 'false');
        navitems.eq(nextSlide).addClass('active');
        navitems.eq(nextSlide).find('.map-container__citynav-item__button').attr('aria-current', 'true');
        const inState = Flip.getState(indicator);
        $(navitems).eq(nextSlide).get(0).appendChild(indicator.get(0));
        
        $(mobileToggle).find('.current').text( navitems.eq(nextSlide).find('.map-container__citynav-item__button').text() );
        
        if ( isMobile ) {
          list.slideUp();
          $(mobileToggle).removeClass('active');
        }
        
        Flip.from(inState, {
          absolute: true,
          duration: 0.6,
          ease: 'power3.inOut'
        });
      });

      slides.on('afterChange', function(event, slick, currentSlide){
        slides.find('.slick-slide').each(function() {
          this.removeAttribute('aria-label');
        });
      });
      
      mobileToggle.on('click', function(){
        if ( isMobile ) {
          $(this).toggleClass('active');
          list.slideToggle();
        }
      });
    });
  }
  
  if ( $('.site-footer').length ) {
    const footer = document.querySelector('footer.site-footer');
    
    const swapFooterElements = (updated) => {
      if ( updated ) {
        const firstFooterSection = footer.querySelector(':scope > *:first-child');
        const lastFooterSection = footer.querySelector(':scope > *:nth-child(2)');
        console.log(firstFooterSection, lastFooterSection);
        
        lastFooterSection.after( firstFooterSection );
      }
    };
    
    if ( isMobile ) {
      swapFooterElements(true);
    }
    
    windowResizeActions.push( swapFooterElements );
  }

  if ( $('.subnav').length ) {
    $('.subnav').each(function(){
      const toggle = $(this).find('.subnav-toggle');
      const inner = $(this).find('.subnav__inner');
      const links = $(this).find('.subnav-links');
      const firstFocusable = inner.find('a, button, input').eq(0).get(0);
      const lastFocusable = inner.find('a, button, input').last().get(0);

      const scrollMonitor = new ScrollableContainer(links.get(0), {
        classTarget: this,
        scrollType: 'horizontal',
        arrows: true,
        appendArrows: inner.get(0)
      });

      toggle.on('click', function(){
        const expanded = $(this).attr('aria-expanded') === 'true' ? 'false' : 'true';
        $(this).attr('aria-expanded', expanded);
        if ( expanded === 'true' ) {
          $(inner).slideDown();
          $(inner).attr('tabindex', '-1');
          $(inner).focus();
        } else {
          $(inner).slideUp();
          $(inner).removeAttr('tabindex');
          $(toggle).focus();
        }
      });
    });
  }

  if ( $('.explore-block--condensed').length ) {
    $('.explore-block--condensed').each(function(){
      const thisRef = this;
      const toggle = $(this).find('.explore-block__locations__toggle');
      const locations =this.querySelector('.explore-block__locations');
      const modal = $(this).find('.explore-block__locations-inner');
      const modalOuter = $(this).find('.explore-block__locations');
      const sticky = $(this).find('.explore-block__locations__toggle-sticky');
      const controlsArea = $(this).find('.explore-block__controls');
      const scroller = new ScrollableContainer( modal.get(0), {
        scrollType: 'vertical',
        arrows: false,
        classTarget: locations
      });

      let isOpen = true;

      windowResizeActions.push( (updated) => {
        if ( updated ) {
          if ( isOpen ) {
            gsap.set(modalOuter, {
                x: '0%',
                y: '0%'
              });
          } else {
            if ( isMobile ) {
              gsap.set(modalOuter, {
                y: '100%',
                x: '0%'
              });
            } else {
              gsap.set(modalOuter, {
                x: '-100%',
                y: '0%'
              });
            }
          }
        }
      });

      gsap.set(controlsArea, {
        '--safe-zone': '40vh'
      });

      toggle.on('click', function(){
        isOpen = !isOpen;
        toggle.toggleClass('active');
        if ( isOpen ) {
          toggle.find('.explore-block__locations__toggle-text--inactive').hide()
          toggle.find('.explore-block__locations__toggle-text--active').show()

          const animTo = isMobile ? {
            y: '0%'
          } : {
            x: '0%'
          };

          gsap.to(controlsArea, {
            '--safe-zone': '0vh',
            duration: 0.6,
            ease: 'power3.inOut',
          });

          gsap.to(modalOuter, {
            ...animTo,
            duration: 0.6,
            ease: 'power3.inOut',
            onStart: function() {
              gsap.set(modal, {
                visibility: 'visible',
                pointerEvents: 'auto'
              })
            }
          })
        } else {
          toggle.find('.explore-block__locations__toggle-text--inactive').show()
          toggle.find('.explore-block__locations__toggle-text--active').hide()
          const animTo = isMobile ? {
            y: '100%'
          } : {
            x: '-100%'
          };

          gsap.to(controlsArea, {
            '--safe-zone': '40vh',
            duration: 0.6,
            ease: 'power3.inOut',
          });

          gsap.to(modalOuter, {
            ...animTo,
            duration: 0.6,
            ease: 'power3.inOut',
            onComplete: function() {
              gsap.set(modal, {
                visibility: 'hidden',
                pointerEvents: 'none'
              })
            }
          })
        }
      });
    });
  }
  
  if ( $('.curated-art-feed').length ) {
    $('.curated-art-feed').each(function(){
      const thisRef = this;
      const indicator = $(this).find('.map-container__citynav-indicator');
      const exhibitStateRadios = $(this).find('input[name="exhibit-state"]');

      const masonryContainer = $(this).find('.curated-art-feed__masonry');
      const items = $(this).find('.curated-art-feed__masonry-item');
      const filters = {
        search: false,
        state: 'current',
        location: 'all'
      };
      let isInitialized = false;

      const applyFilters = () => {
        console.log($(thisRef).find('.curated-art-feed__masonry-item, .curated-art-feed__feed'));
        const state = Flip.getState($(thisRef).find('.curated-art-feed__masonry-item, .curated-art-feed__feed'));

        $(items).each(function(){
          const data = $(this).find('button').data();
          console.log(data);
          let passesAllFilters = true;
          if ( data.state !== filters.state ) {
            passesAllFilters = false;
          }

          if ( filters.location !== 'all' && data.propertyslug !== filters.location ) {
            passesAllFilters = false;
          }

          if ( passesAllFilters ) {
            $(this).show();
            $(this).addClass('active');
          } else {
            $(this).hide();
            $(this).removeClass('active');
          }
        });

        if ( isInitialized ) {
          $(masonryContainer).masonry('destroy');
          $(masonryContainer).masonry({
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: '.curated-art-feed__masonry-item.active',
            percentPosition: true
          });

          Flip.from(state, {
            absolute: false, // uses position: absolute during the flip to work around flexbox challenges
            duration: 1.6,
            stagger: 0.1,
            ease: "power3.inOut",
            onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
            onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
          });

          
        } else {
          $(masonryContainer).masonry({
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: '.curated-art-feed__masonry-item.active',
            percentPosition: true
          });
        }

        isInitialized = true;
      }

      applyFilters();

      $(this).find('.curated-art-select__hidden-input').on('change', function(){
        filters.location = $(this).val();
        applyFilters();
      });

      exhibitStateRadios.on('change', function(){
        if ( $(this).is(":checked") ) {
          const inState = Flip.getState(indicator);
          $(this).parent().get(0).appendChild(indicator.get(0));
          Flip.from(inState, {
            absolute: true,
            duration: 0.6,
            ease: 'power3.inOut'
          });
          $(exhibitStateRadios).parent().removeClass('active');
          $(this).parent().addClass('active');
          filters.state = $(this).val();
          applyFilters();
        } else {
          
        }
      });

      const modal = $(this).next('.curated-art-feed__modal');
      const modalClose = modal.find('.curated-art-feed__modal-close');
      
      const closeModal = () => {
        const tl = gsap.timeline({
          repeat: false,
          onComplete: function(){
            modal.css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        tl.to(modal.find('.curated-art-feed__modal-info'), {
          x: '100%',
          duration: 0.6,
          ease: 'power3.inOut',
        });

        tl.to(modal.find('.curated-art-feed__modal-image'), {
          scale: 0.96,
          duration: 0.6,
          ease: 'power3.inOut',
        }, '0');

        tl.to(modal, {
          opacity: 0,
          duration: 0.6,
          ease: 'power3.inOut'
        }, '-=0.4');
      };

      modalClose.on('click', function(){
        closeModal();
      });

      $(this).find('.curated-art-feed__masonry-item button').each(function(){
        $(this).on('click', function(){
          const data = $(this).data();

          modal.find('.curated-art-feed__modal-image').attr('src', data.src[0]);
          modal.find('.curated-art-feed__modal-image').attr('width', data.src[1]);
          modal.find('.curated-art-feed__modal-image').attr('height', data.src[2]);
          modal.find('.curated-art-feed__modal-image').attr('alt', data.alt);
          modal.find('.curated-art-feed__modal-title').text(data.title);

          if ( data.year ) {
            modal.find('.curated-art-feed__modal-title').text( data.title + ',' );
            const year = document.createElement('span');
            year.textContent = ' ' + data.year;
            year.style.fontWeight = '400';
            modal.find('.curated-art-feed__modal-title').append(year);
          }

          if ( data.artist ) {
            modal.find('.curated-art-feed__modal-artist').text(data.artist);
            modal.find('.curated-art-feed__modal-artist').show();
            if ( data.artistauxtext ) {
              const aux = document.createElement('span');
              aux.textContent = ' ' + data.artistauxtext;
              aux.style.fontWeight = '400';
              modal.find('.curated-art-feed__modal-artist').append(aux);
            }
          } else {
            modal.find('.curated-art-feed__modal-artist').hide();
          }

          if ( data.description ) {
            modal.find('.curated-art-feed__modal-description').html(data.description).show();
          } else {
            modal.find('.curated-art-feed__modal-description').hide();
          }

          if ( data.property ) {
            modal.find('.curated-art-feed__modal-property').text(data.property).show();
          } else {
            modal.find('.curated-art-feed__modal-property').hide();
          }

          if ( data.dimensions ) {
            modal.find('.curated-art-feed__modal-dimensions').text(data.dimensions).show();
          } else {
            modal.find('.curated-art-feed__modal-dimensions').hide();
          }

          if ( data.purchasable ) {
            modal.find('.curated-art-feed__modal-purchase-holder').show();
          } else {
            modal.find('.curated-art-feed__modal-purchase-holder').hide();
          }

          modal.css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          })

          gsap.set(modal.find('.curated-art-feed__modal-image'), {
            scale: 0.96
          });

          const tl = gsap.timeline({
            repeat: false
          });

          tl.to(modal, {
            opacity: 1,
            duration: 0.6,
            ease: 'power3.inOut'
          });

          tl.to(modal.find('.curated-art-feed__modal-image'), {
            scale: 1,
            duration: 0.6,
            ease: 'power3.inOut',
          }, '0.2');

          tl.fromTo(modal.find('.curated-art-feed__modal-info'), {
            x: '100%'
          }, {
            x: 0,
            duration: 0.6,
            ease: 'power3.inOut',
          }, '0.2');

          console.log(modal);
        });
    });
  })
}

//   if ( $('.social-cloud').length ) {
//     $('.social-cloud').each(function(){
//       const images = $(this).find('.social-cloud__image img');
//       const scrollTL = gsap.timeline({
//         paused: true,
//         repeat: 0,
//         scrollTrigger: {
//           trigger: this,
//           start: 'top bottom',
//           end: 'bottom bottom',
//           scrub: 2,
//         }
//       });
// 
//       $(images).each(function(){
//         scrollTL.from(this, {
//           opacity: 0,
//           y: 96,
//           scale: 0.96,
//           duration: 1.2
//         }, '-=0.8');
//       });
// 
//     });
// 
//   }
  /* END GUTENBERG SCRIPTS */
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  isMobile = ( windowWidth <= mobileBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/

function freeze_gif(i) {
  console.log(i);
  var c = document.createElement('canvas');
  var w = c.width = i.width;
  var h = c.height = i.height;
  const context = c.getContext('2d');
  context.drawImage(i, 0, 0, w, h);
  try {
      c.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
      
        i.onload = () => {
          // no longer need to read the blob so it's revoked
          URL.revokeObjectURL(url);
        };
      
        i.src = url;
      });
  } catch(e) { // cross-domain -- mimic original with all its tag attributes
    console.log(e);
      for (var j = 0, a; a = i.attributes[j]; j++)
          c.setAttribute(a.name, a.value);
      i.parentNode.replaceChild(c, i);
  }
}

class ScrollableContainer {
  constructor(scrollableNode, args = {}) {
    const {
      scrollType,
      scrollPadding = 32,
      classTarget = null,
      arrows = false,
      appendArrows = null
    } = args;

    this.scroller = scrollableNode;
    this.classTarget = classTarget && classTarget instanceof HTMLElement ? classTarget : this.scroller;
    this.scrollType = scrollType && ['horizontal', 'vertical'].includes(scrollType) ? scrollType : 'vertical';
    this.scrollPadding = typeof scrollPadding === 'number' ? scrollPadding : 32;
    this.arrows = typeof arrows === 'boolean' ? arrows : false;
    this.appendArrows = appendArrows && appendArrows instanceof HTMLElement ? appendArrows : this.classTarget;

    this.assessScroll();

    $(window).on('resize', (() => {
      this.assessScroll();
    }).bind(this));

    ScrollTrigger.create({
      scroller: this.scroller,
      horizontal: this.scrollType === 'horizontal',
      start: this.scrollPadding * -1,
      end: (() => {
        return this.scrollType === 'horizontal' ? this.scroller.scrollWidth - this.scroller.clientWidth : this.scroller.scrollHeight - this.scroller.clientHeight;
      }).bind(this),
      // markers: true,
      toggleClass: {
        targets: this.classTarget,
        className: 'can-scroll-positive'
      }
    })

    ScrollTrigger.create({
      scroller: this.scroller,
      horizontal: this.scrollType === 'horizontal',
      start: this.scrollPadding,
      end: (() => {
        return this.scrollType === 'horizontal' ? this.scroller.scrollWidth - this.scroller.clientWidth + this.scrollPadding : this.scroller.scrollHeight - this.scroller.clientHeight + this.scrollPadding;
      }).bind(this),
      // markers: true,
      toggleClass: {
        targets: this.classTarget,
        className: 'can-scroll-negative'
      }
    })

    if ( this.arrows !== null && this.arrows !== false ) {
      this.appendArrows.insertAdjacentHTML('afterbegin', prevArrow);
      this.appendArrows.insertAdjacentHTML('beforeend', nextArrow);

      this.nextArrow = this.appendArrows.querySelector('.slick-next');
      this.prevArrow = this.appendArrows.querySelector('.slick-prev');
      
      this.nextArrow.addEventListener('click', (e) => {
        e.preventDefault();
        const scrollAmount = this.scrollType === 'horizontal' ? this.scroller.clientWidth - this.scrollPadding : this.scroller.clientHeight - this.scrollPadding;
        if ( this.scrollType === 'horizontal' ) {
          gsap.to(this.scroller, {
            scrollTo: {
              x: this.scroller.scrollLeft + scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        } else {
          gsap.to(this.scroller, {
            scrollTo: {
              y: this.scroller.scrollTop + scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        }
      });

      this.prevArrow.addEventListener('click', (e) => {
        e.preventDefault();
        const scrollAmount = this.scrollType === 'horizontal' ? this.scroller.clientWidth - this.scrollPadding : this.scroller.clientHeight - this.scrollPadding;
        if ( this.scrollType === 'horizontal' ) {
          gsap.to(this.scroller, {
            scrollTo: {
              x: this.scroller.scrollLeft - scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        } else {
          gsap.to(this.scroller, {
            scrollTo: {
              y: this.scroller.scrollTop - scrollAmount
            },
            ease: 'power3.inOut',
            duration: 0.8
          });
        }
      });
    }
  }

  assessScroll() {
    this.isScrollable = this.scrollType === 'horizontal' ? this.scroller.scrollWidth > this.scroller.clientWidth : this.scroller.scrollHeight > this.scroller.clientHeight;
    console.log( this.scroller.scrollHeight, this.scroller.clientHeight, this.isScrollable );

    if ( this.isScrollable ) {
      this.classTarget.classList.add('is-scrollable');
    } else {
      this.classTarget.classList.remove('is-scrollable');
    }
  }
}